import api from "@/api/viktor"

export async function getSharepools() {
  const response = await api({
    method: "get",
    url: `/me/sharepools`,
  })

  return response
}
